let ControllerName = 'courses';
const CourseControllers = Object.freeze({
    AllCoursesData: `${ControllerName}`,
    CourseById: `${ControllerName}/course-by-id`,
    LatestCoursesMenu : `${ControllerName}/latest`,
    featuredCourses : `${ControllerName}/featured`,
    notification : `${ControllerName}/me`,
    courseDemo : `${ControllerName}/lecture/demo`
});

export default CourseControllers;